import { ErrorType, ErrorMessage } from '@ilteducation/quizter-types/game-api';

export interface ErrorState {
  errorType: ErrorType | null;
  errorMessage: string | null;
}

const SCREEN_ERRORS = new Set([ErrorType.LOGIN_REQUIRED, ErrorType.INVALID_ACCESS_TOKEN, ErrorType.SESSION_SUPERSEDED]);

export function handleError(payload: ErrorMessage['payload']): ErrorState {
  if (payload.errorType === ErrorType.LOBBY_FULL) {
    return {
      errorType: ErrorType.LOBBY_FULL,
      errorMessage: 'Tyvärr, lobbyn är redan full',
    };
  }
  if (payload.errorType === ErrorType.GAME_NOT_FOUND) {
    return {
      errorType: ErrorType.GAME_NOT_FOUND,
      errorMessage: null,
    };
  }
  if (payload.errorType === ErrorType.PLAYER_CANNOT_JOIN) {
    return {
      errorType: ErrorType.PLAYER_CANNOT_JOIN,
      errorMessage: 'Tyvärr, du kan inte gå med i det här spelet',
    };
  }
  // Each has its own screen. The message is left to the view, which has the translations.
  if (payload.errorType && SCREEN_ERRORS.has(payload.errorType)) {
    return {
      errorType: payload.errorType,
      errorMessage: null,
    };
  }
  // Other errors ignored
  return {
    errorType: null,
    errorMessage: null,
  };
}

export function clearError(): ErrorState {
  return {
    errorType: null,
    errorMessage: null,
  };
}
